<div class="overlay">
	<div *ngIf="showOverlay" class="overlay__backdrop">
	</div>

	<div class="overlay__content">
		<ng-content select="[overlayContent]"></ng-content>
	</div>

	<ng-content select="[wrappedContent]"></ng-content>
</div>
